module.exports = {
      id: "nagorik-usage",
      viewBox: "0 0 336 47",
      url: "/" + "sprite-326d1762f7ed1f924194ae9c5468ee69.svg#nagorik",
      toString: function () {
        return this.url;
      }
    }